<template>
    <div>
        <h1 class="display-heading mb-3">Appointments Request</h1>

        <tab-view :tabs="tabs" :activeTab.sync="activeTab">
            <template v-if="activeTab===0">
                <appointment-detail
                    class="mb-3"
                    participantNameDisplay="Patient Name"
                    :isConsultation="true"
                    :consultationId="consultation.consultationId"
                    :appointmentDate="consultation.startTime"
                    :appointmentParticipant="consultation.participantName"
                    :isDoctor="true"
                    :patientGender="consultation.patientGender"
                    :patientAge="consultation.patientAge">

<!-- consultation.doctorName -->
                    </appointment-detail>

                    <div v-if="consultation.appointmentStatus===0">
                        <a href="javascript: void(0);" @click="acceptRequest" class="btn btn-primary btn-primary-insv mr-2">
                            Accept Request
                        </a>
                        <a href="javascript: void(0);" @click="cancelSession" class="btn btn-danger">
                            Reject Request
                        </a>
                    </div>
                    <div class="mt-5 font-italic" v-else>
                        <p>Appointment has already been accepted / rejected previously.</p>
                    </div>
            </template>
            <template v-if="activeTab===1">
                <questionnaire-covid19 ref="questionnaireCovid19" :isNew="false" :consultationId="consultation.consultationIdGuid" :patientName="consultation.participantName"
                :patientIcNumber="consultation.participantIcNumber">
                </questionnaire-covid19>
            </template>
        </tab-view>

        <popup-modal ref="popupModalConfirmation" :hasCloseButton="false" title="Reject Appointment Request">
            <template slot="content">
                <p>{{confirmationMessage}}</p>

                <template v-if="!isCancelling">
                    <label>Reason</label>
                    <input id="inputReason" type="text" class="form-control" placeholder="Enter reason" v-model="cancelReason">
                </template>
            </template>
            <template slot="footer">
                <button type="button" class="btn btn-danger" @click="confirmRejectSession">Reject Session</button>
                <button type="button" class="btn btn-secondary" @click="dismissCancelSession">Cancel</button>
            </template>
        </popup-modal>

        <popup-modal ref="popupAcceptResponse" :hasCloseButton="false" title="Appointment Accepted!">
            <template slot="content">
                <p>This patient's request has been accepted by you!</p>

                <template v-if="consultation.isOnDemand">
                    <p>
                        Please move to "Dashboard" page and wait for patient making payment.
                    </p>
                    <p>
                        Action status will be changed to "Start Session" when payment is made successfully.
                    </p>
                    <p>
                         Then click "Start Session" to begin your tele-consultation.
                    </p>
                </template>
                <template v-else>
                    <p>
                        Email will be issued to patient for getting payment.
                    </p>
                    <p>
                        Confirmation of scheduled appointment will be sent to you via email, once payment is done by patient later.
                    </p>
                    <p>
                        Another email will be issued to you as reminder of any paid scheduled appointment, 24 hour in advanced.
                    </p>
                </template>
            </template>
            <template slot="footer">
                <button type="button" class="btn btn-primary btn-primary-insv" @click="goToDashboardAccepted">Move to Dashboard Page</button>
            </template>
        </popup-modal>

        <popup-modal ref="popupRejectResponse" :hasCloseButton="false" title="Appointment Rejected">
            <template slot="content">
                <p>
                    This patient’s request has been rejected, a notification will be sent to patient soon.
                </p>
            </template>
            <template slot="footer">
                <button type="button" class="btn btn-primary btn-primary-insv" @click="goToDashboardRejected">Back to Dashboard Page</button>
            </template>
        </popup-modal>
    </div>
</template>

<script>
import tabView from '@/components/tab-view';
import popupModal from '@/components/popup-modal';
import appointmentDetail from '@/components/appointment-detail';
import questionnaireCovid19 from '@/components/questionnaires/covid-19';
export default {
    'name': 'ViewAppointmentRequest',
    'components': {
        tabView,
        appointmentDetail,
        popupModal,
        questionnaireCovid19
    },
    'computed': {
        appointmentId () {
            return this.$route.params.id;
        },
        shouldShowCovid19Form () {
            return this.$store.state.shouldShowCovid19Form;
        },
        tabs () {
            if (this.shouldShowCovid19Form) {
                return ['Patient Details', 'Covid-19 Questionnaire'];
            }
            return ['Patient Details'];
        }
    },
    data () {
        return {
            'consultation': {
                'startTime': null,
                'consultationId': null,
                'participantName': null,
                'participantIcNumber': null,
                'doctorName': null,
                'patientGender': '',
                'patientAge': '-1',
                'isOnDemand': false,
                'consultationIdGuid': null,
                'appointmentStatus': 0
            },
            'isCancelling': false,
            'confirmationMessage': null,
            'cancelReason': null,
            'activeTab': 0
        };
    },
    mounted () {
        if (this.appointmentId) {
            this.getAppointmentRequest(this.appointmentId);
        }
    },
    'methods': {
        getAppointmentRequest (appointmentId) {
            this.axios.get('Appointment/DoctorGetAppointmentRequest', {
                'params': {
                    'appointmentId': appointmentId
                }
            }).then(({
                data
            }) => {
                let consultation = data.data;

                this.consultation.startTime = consultation.ss;
                this.consultation.consultationId = consultation.dc ? consultation.dc.cis : null;
                this.consultation.participantName = consultation.cp ? consultation.cp.fn : null;
                this.consultation.participantIcNumber = consultation.cp ? consultation.cp.icn : null;
                this.consultation.doctorName = consultation.d ? consultation.d.n : null;
                this.consultation.patientGender = consultation.cp ? consultation.cp.g : null;
                this.consultation.patientAge = consultation.cp ? consultation.cp.a : null;
                this.consultation.isOnDemand = consultation.iod;
                this.consultation.consultationIdGuid = consultation.dc ? consultation.dc.ci : null;

                this.consultation.appointmentStatus = consultation.si;
            }).catch((response) => {});
        },
        acceptRequest () {
            this.axios.post('Appointment/DoctorAcceptAppointmentRequest', null, {
                'params': {
                    'appointmentId': this.appointmentId
                }
            }).then(() => {
                this.$refs.popupAcceptResponse.show();
            }).catch(({
                response
            }) => {

            });
        },
        cancelSession () {
            this.isCancelling = false;
            this.cancelAppointmentId = this.appointmentId;
            this.confirmationMessage = 'Are you sure you want to reject this appointment request? This action cannot be undone.';

            this.$refs.popupModalConfirmation.show();
        },
        confirmRejectSession () {
            this.isCancelling = true;
            this.confirmationMessage = 'Rejecting consultation session...';
            this.axios.post('Appointment/DoctorCancelAppointment', null, {
                'params': {
                    'appointmentId': this.appointmentId,
                    'cancelReason': this.cancelReason
                }
            }).then(() => {
                this.$refs.popupModalConfirmation.hide().then(() => {
                    this.$refs.popupRejectResponse.show();
                });
            }).catch(() => {
                alert('Error cancelling appointment. Please try again.');
            });
        },
        dismissCancelSession () {
            this.cancelReason = null;
            this.cancelAppointmentId = null;
            this.$refs.popupModalConfirmation.hide();
        },
        goToDashboardAccepted () {
            this.$refs.popupAcceptResponse.hide().then(() => {
                this.$router.push({
                    'name': 'dashboard-doctor'
                });
            });
        },
        goToDashboardRejected () {
            this.$refs.popupRejectResponse.hide().then(() => {
                this.$router.push({
                    'name': 'dashboard-doctor'
                });
            });
        }
    }
};
</script>
